import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { setItemInCart } from "./redux/cart/cartSlice";
import { useDispatch } from "react-redux";
import { CSSTransition } from "react-transition-group";

function ProductItem({ furniture }) {
  const { id } = useParams();
  const furnitureItem = furniture.find((item) => item.id === id);
  const dispatch = useDispatch();
  const [showAddedToCart, setShowAddedToCart] = useState(false);
  const [isImageOpen, setIsImageOpen] = useState(false);

  const addInCart = () => {
    dispatch(setItemInCart(furnitureItem));
    setShowAddedToCart(true);
    setTimeout(() => {
      setShowAddedToCart(false);
    }, 2000);
  };

  if (!furnitureItem) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
     <div className="w-full max-w-5xl bg-white p-8 rounded-2xl shadow-xl">
        <Link
          to="/"
          className="text-gray-600 hover:text-gray-800 mb-4 inline-block"
        >
          <ion-icon
            name="chevron-back-outline"
            class="text-xl align-middle"
          ></ion-icon>
          <span className="align-middle ml-2">Артка кайтуу</span>
        </Link>

        <div className="grid md:grid-cols-2 gap-8 px-6 pb-8 pt-6">
          <div className="flex items-center justify-center bg-gray-100 rounded-xl p-4">
            <img
              src={furnitureItem.img}
              alt={furnitureItem.title}
              onClick={() => setIsImageOpen(true)}
              className="w-full h-[360px] object-cover rounded-xl cursor-zoom-in hover:scale-105 transition"
            />
          </div>

          <div className="flex flex-col justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">
                {furnitureItem.title}
              </h1>

              <p className="text-gray-600 mt-4 leading-relaxed">
                {furnitureItem.subtext}
              </p>

              <div className="flex items-end gap-2 mt-8">
                <span className="text-4xl font-bold text-[#2A254B]">
                  {furnitureItem.price}
                </span>
                <span className="text-lg font-semibold text-[#2A254B]">
                  сом
                </span>
              </div>
            </div>

            <button
              onClick={addInCart}
              className="mt-10 w-full bg-[#A1C349] hover:bg-[#9ab556] text-white py-4 rounded-xl text-lg font-semibold transition shadow-md hover:shadow-lg"
            >
              Корзинага кошуу
               <CSSTransition
              in={showAddedToCart}
              timeout={200}
              classNames="fade-in"
              unmountOnExit
            >
              <div className="added-to-cart">Себетке кошулду</div>
            </CSSTransition>
            </button>
          </div>
        </div>
      </div>
      {isImageOpen && (
        <div
          onClick={() => setIsImageOpen(false)}
          className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm 
               flex items-center justify-center px-4"
        >
          <img
            src={furnitureItem.img}
            alt={furnitureItem.title}
            onClick={(e) => e.stopPropagation()}
            className="max-w-full max-h-full rounded-2xl shadow-2xl 
                 cursor-zoom-out animate__animated animate__fadeIn"
          />

          <button
            onClick={() => setIsImageOpen(false)}
            className="absolute top-6 right-6 text-white text-3xl 
                 hover:scale-110 transition"
          >
            ✕
          </button>
        </div>
      )}
    </div>
  );
}

export default ProductItem;
